var _rect, _path, _path2, _path3, _line, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#4f0abf"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#9333ea"
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "url(#bg)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 22 L4 10 Q4 9 5 9 Q10 9 16 12 Q22 9 27 9 Q28 9 28 10 L28 22 Q28 23 27 23 Q22 23 16 20 Q10 23 5 23 Q4 23 4 22Z",
    fill: "white",
    opacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 22 L4 10 Q4 9 5 9 Q10 9 16 12 L16 24 Q10 21 5 21 Q4 21 4 20Z",
    fill: "white",
    opacity: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 22 L28 10 Q28 9 27 9 Q22 9 16 12 L16 24 Q22 21 27 21 Q28 21 28 20Z",
    fill: "white",
    opacity: 0.65
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 12,
    x2: 16,
    y2: 24,
    stroke: "#9333ea",
    strokeWidth: 1,
    opacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-40, 26, 6)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 3,
    width: 3,
    height: 10,
    rx: 0.5,
    fill: "#fde68a"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "23,13 26,13 24.5,16",
    fill: "#fca5a5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 3,
    width: 3,
    height: 2,
    rx: 0.5,
    fill: "#9ca3af"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon);
export default __webpack_public_path__ + "static/media/favicon.3e8a0da31931e0c4a844799e00b585b3.svg";
export { ForwardRef as ReactComponent };